import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import SidebarMenu from "../../../Components/SidebarMenu";
import api from "../../../Services/api";
import { Page } from "../../SignedOut/Cadastro/styles";
import { PageTitle } from "../CadastrarMedico/styles";
import ReactLoading from "react-loading";
import { useHistory } from "react-router";
import PageContainer from "../../../Components/PageContainer";
import InfosMedico from "../../../Components/InfosMedico";
import InfosVendedor from "../../../Components/InfosVendedor";
import { Info } from "../PacienteUnico/styles";
import { toast } from "react-toastify";
import BlockButton from "../../../Components/BlockButton";
import MainButton from "../../../Components/MainButton";
import { ButtonContainer } from "./styles";

export default function PendenteUnico() {
  const { id } = useParams();
  const [prestador, setPrestador] = useState([]);
  const [loading, setLoading] = useState(true);
  const [requestDone, setRequestDone] = useState(false);
  const [loadingStatus, setLoadingStatus] = useState(false);

  const history = useHistory();

  async function handleStatusChange(id, novoStatus) {
    setLoadingStatus(true);
    try {
      const trocaStatus = await api.patch(`/usuario/alterar_status/${id}`, { ST_usuario: novoStatus });
      console.log(handleStatusChange);
      const showToastMessage = () => {
        toast.success(`Status do paciente alterado`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessage();
      history.push("/pacientes");
    } catch (error) {
      const showToastMessageError = () => {
        toast.error(`Não foi possível alterar o status do paciente`, {
          position: toast.POSITION.TOP_CENTER,
        });
      };
      showToastMessageError();
      console.log(error);
    }
    finally {
      setLoadingStatus(false);
    }
  }

  const fetchRepositoriesData = async () => {
    setLoading(true);
    try {
      console.log('id pendente', id);
      const response = await api.get(`/medicos/medicos/listar/${id}`);
      console.log('pendente', response.data);
      setPrestador(response.data);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      setRequestDone(true);
    }
  };

  useEffect(() => {
    fetchRepositoriesData();
  }, [id]);

  if (loading || !requestDone) {
    return (
      <Page>
        <SidebarMenu />
        <PageContainer>
          <PageTitle>Prestador</PageTitle>
          <ReactLoading
            type="spin"
            color="#B2EBF2"
            height={"30px"}
            width={"30px"}
          />
        </PageContainer>
      </Page>
    );
  }

  if (prestador) {
    return (
      <InfosMedico
        prestador={prestador}
        pendente
        buttons={
          <ButtonContainer>
            <MainButton
              onClick={() => handleStatusChange(prestador.usuario.id_usuario, "ATIVO")}
              disabled={loadingStatus}
              bgcolor="green"
            >
              {
              loadingStatus ?
              <ReactLoading
                type="spin"
                color="#ffffff"
                height={"30px"}
                width={"30px"}
                className="m-auto"
              />
              :
              "Aceitar"
              }
            </MainButton>
            <MainButton
              onClick={() => handleStatusChange(prestador.usuario.id_usuario, "SUSPENSO")}
              bgcolor="red"
              disabled={loadingStatus}
            >
              {
              loadingStatus ?
              <ReactLoading
                type="spin"
                color="#ffffff"
                height={"30px"}
                width={"30px"}
                className="m-auto"
              />
              :
              "Recusar"
              }
            </MainButton>
          </ButtonContainer>
        }
      />
    );
  } else {
    <PageContainer>
      <Info>Erro ao carregar prestador</Info>
    </PageContainer>;
  }

}
